import React from "react";

const PartnerPopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: "16px", // breathing room on small screens
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          padding: "32px 28px",
          maxWidth: "400px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* <div style={{ fontSize: "48px", marginBottom: "12px" }}>📋</div> */}
        <p
          style={{
            fontSize: "15px",
            fontWeight: "600",
            color: "#1a1a1a",
            marginBottom: "8px",
            lineHeight: "1.6",
          }}
        >
          Registrations will open after 5 days.
          <br />
          For more information WhatsApp or call{" "}
          <a
            href="tel:9289440049"
            style={{
              color: "#1e5799",
              textDecoration: "none",
              fontWeight: "700",
            }}
          >
            9289440049
          </a>
        </p>
        <p
          style={{
            fontSize: "14px",
            color: "#555",
            lineHeight: "1.6",
            marginBottom: "20px",
          }}
        >
          रजिस्ट्रेशन 5 दिनों बाद खुलेगा।
          <br />
          अधिक जानकारी के लिए WhatsApp या कॉल करें{" "}
          <a
            href="tel:9289440049"
            style={{
              color: "#1e5799",
              textDecoration: "none",
              fontWeight: "700",
            }}
          >
            9289440049
          </a>
        </p>
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <a
            href="https://wa.me/919289440049?text=Hi%2C%20I%20want%20to%20know%20more%20about%20DocMaster%20services."
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: "#25d366",
              color: "#fff",
              padding: "10px 22px",
              borderRadius: "50px",
              fontWeight: "700",
              fontSize: "14px",
              textDecoration: "none",
            }}
          >
            WhatsApp
          </a>
          <button
            onClick={onClose}
            style={{
              background: "#f1f5f9",
              color: "#333",
              padding: "10px 22px",
              borderRadius: "50px",
              fontWeight: "600",
              fontSize: "14px",
              border: "none",
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PartnerPopup;
